import { render } from "./BikeRecommender.vue?vue&type=template&id=5f70a522"
import script from "./BikeRecommender.vue?vue&type=script&lang=js"
export * from "./BikeRecommender.vue?vue&type=script&lang=js"

import "./BikeRecommender.vue?vue&type=style&index=0&id=5f70a522&lang=css"

import exportComponent from "/Users/haoche/Documents/Parsons/2024 Spring/Major Studio 2/thesis/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__